import i18next from 'i18next';
import { OverviewDashboardSortEnum } from 'infrastructure/enums';

export interface IOverviewDashboardSortItem {
  id: OverviewDashboardSortEnum | null;
  name: string;
}

export const overviewDashboardSortDataSource = (
  withNone = true,
): IOverviewDashboardSortItem[] => {
  const dataSource: IOverviewDashboardSortItem[] = [
    {
      id: OverviewDashboardSortEnum.Newest,
      name: i18next.t('overviewDashboardSort.newest'),
    },
    {
      id: OverviewDashboardSortEnum.LastCritical,
      name: i18next.t('overviewDashboardSort.lastCritical'),
    },
    {
      id: OverviewDashboardSortEnum.LastAtRisk,
      name: i18next.t('overviewDashboardSort.lastAtRisk'),
    },
  ];

  if (withNone) {
    dataSource.unshift({
      id: null,
      name: i18next.t('overviewDashboardSort.all'),
    });
  }

  return dataSource;
};
